import type { ProductImage } from "./videoCreatingSlice";

/** setLibraryInit：单张商品图（库选 / 上传） */
export interface LibraryInitProductImageInput {
  /** 有可能没有assetId */
  assetId?: number;
  imageUrl: string;
  aiAnalyzed?: boolean;
}

/** setLibraryInit：商品快照（与 reducer 解构字段一致） */
export interface LibraryInitProductPayload {
  id?: string;
  country?: string;
  productTitle?: string;
  images?: LibraryInitProductImageInput[];
  priCateName?: string;
  secCateName?: string;
  terCateName?: string;
}

/** setLibraryInit 的 action.payload */
export interface SetLibraryInitPayload {
  product?: LibraryInitProductPayload;
}

/** setStepStatus：与 VideoCreatingState.stepStatus 字段一致的部分更新 */
export type VideoCreatingStepStatusPayload = Partial<{
  basicInfoInit: boolean;
  productInfoInit: boolean;
  descParamsInit: boolean;
  currentStep: number;
}>;

/** 判断图片是否已经打标了 */
export const imageHasDescription = (image: ProductImage | string | null | undefined) => {
  if (!image) return false;
  if (typeof image === "string") return image.trim() !== "";
  return !!image.description && image.description.trim() !== "";
};
